import { Box, Typography, useTheme } from '@mui/material';
import { useGetOrganizations } from 'apis/agency/organizations/hook';
import WelcomeImg from 'assets/welcome.webp';
import Button from 'components/Common/Button';
import { useNavigate } from 'react-router-dom';

export default function Welcome() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { data: organizations } = useGetOrganizations();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100vh',
        textAlign: 'center'
      }}
    >
      <img src={WelcomeImg} alt='welcome user' />
      <Typography
        sx={{
          fontSize: '32px',
          marginTop: '40px',
          fontWeight: '500'
        }}
      >
        Reserved for You—Access Coming Soon! 🚀
      </Typography>
      <Typography sx={{ marginTop: '16px' }}>
        Thanks for joining us. You're queued for {organizations?.name} due to high demand. We’ll notify you as soon as a
        spot opens up!
      </Typography>
      <Button
        sx={{
          paddingX: '100px',
          marginY: '24px'
        }}
        onClick={() => navigate('/auth/logout')}
      >
        Back to Home
      </Button>
      <Typography> Need assistance? </Typography>
      <Typography>
        Reach out at
        <a
          href={`mailto:${organizations?.support_email}`}
          style={{ textDecoration: 'none', color: theme.palette.primary.main, fontWeight: '500', marginLeft: '5px' }}
        >
          {organizations?.support_email}
        </a>
      </Typography>
    </Box>
  );
}
